<template>
    <div>
        <sweet-modal blocking :title="state === 'create' ? $t('modal_payXoft_addSchedule') : $t('modal_payXoft_editSchedule')" ref="addScheduleModal" class="add-schedule-modal" v-on:close="close">
            <el-form label-position="left" :model="formAddSchedule" status-icon :rules="rules" ref="formAddSchedule" class="add-schedule-form">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleName')" size="mini" prop="name">
                            <el-input :placeholder="$t('modal_payXoft_scheduleName')" v-model="formAddSchedule.name"></el-input>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleCode')" size="mini" prop="code">
                            <el-input :placeholder="$t('modal_payXoft_scheduleCode')" v-model="formAddSchedule.code"></el-input>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleTimezone')" size="mini" prop="timezone">
                            <el-select v-model="formAddSchedule.timezone" :placeholder="$t('modal_payXoft_scheduleTimezone')" style="width:100%;">
                                <el-option
                                        v-for="item in formAddSchedule.timezoneList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleWorkdaysInYear')" size="mini" prop="workdaysInYear">
                            <el-input :placeholder="$t('modal_payXoft_scheduleWorkdaysInYear')" v-model="formAddSchedule.workdaysInYear"></el-input>
                        </el-form-item>
                        <el-form-item label-width="135px"  label-position="left" :label="$t('modal_payXoft_scheduleWorkWeekStartDay')" size="mini" prop="workWeekStartDay">
                            <el-select v-model="formAddSchedule.workWeekStartDay" :placeholder="$t('modal_payXoft_scheduleWorkWeekStartDay')" style="width:100%;">
                                <el-option
                                        v-for="item in formAddSchedule.workWeekStartDayList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleStartTime')" size="mini" prop="startTime">
                            <el-time-select
                                    v-model="formAddSchedule.startTime"
                                    :picker-options="{
                                            start: '08:00',
                                            step: '00:30',
                                            end: '24:00'
                                          }"
                                    :placeholder="$t('modal_payXoft_scheduleStartTime')"
                                    style="width: 100%;">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleGraceTime')" size="mini" prop="graceTime">
                            <el-input :placeholder="$t('modal_payXoft_scheduleGraceTime')" v-model="formAddSchedule.graceTime"></el-input>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleEarlyStartFrom')" size="mini" prop="earlyStartFrom">
                            <el-time-select
                                    v-model="formAddSchedule.earlyStartFrom"
                                    :picker-options="{
                                            start: '08:00',
                                            step: '00:30',
                                            end: '24:00'
                                          }"
                                    :placeholder="$t('modal_payXoft_scheduleEarlyStartFrom')"
                                    style="width: 100%;">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleFinishTime')" size="mini" prop="finishTime">
                            <el-time-select
                                    v-model="formAddSchedule.finishTime"
                                    :picker-options="{
                                            start: '08:00',
                                            step: '00:30',
                                            end: '24:00'
                                          }"
                                    :placeholder="$t('modal_payXoft_scheduleFinishTime')"
                                    style="width: 100%;">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleLateFinishTo')" size="mini" prop="lateFinishTo">
                            <el-time-select
                                    v-model="formAddSchedule.lateFinishTo"
                                    :picker-options="{
                                            start: '08:00',
                                            step: '00:30',
                                            end: '24:00'
                                          }"
                                    :placeholder="$t('modal_payXoft_scheduleLateFinishTo')"
                                    style="width: 100%;">
                            </el-time-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleStartDate')" size="mini" prop="startDate">
                            <el-date-picker
                                    format="d MMM yy"
                                    v-model="formAddSchedule.startDate"
                                    type="date"
                                    value-format="ddMMyyyy"
                                    :placeholder="$t('modal_payXoft_scheduleStartDate')"
                                    style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleEndDate')" size="mini" prop="endDate">
                            <el-date-picker
                                    format="d MMM yy"
                                    v-model="formAddSchedule.endDate"
                                    type="date"
                                    value-format="ddMMyyyy"
                                    :placeholder="$t('modal_payXoft_scheduleEndDate')"
                                    style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleRepeat')" size="mini" prop="repeat">
                            <el-input type="number" :placeholder="$t('modal_payXoft_scheduleRepeat')" v-model="formAddSchedule.repeat"></el-input>
                        </el-form-item>
                        <span>{{$t('modal_payXoft_scheduleOvertime')}}</span>
                        <el-form-item label-width="130px" label-position="left" :label="$t('modal_payXoft_schedulePreApproved')" size="mini" prop="preApproved">
                            <el-checkbox @change="changePreApproved()" v-model="formAddSchedule.preApproved"></el-checkbox>
                        </el-form-item>
                        <div v-if="formAddSchedule.preApproved">
                            <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_schedulePreApprovedStartDate')" size="mini" prop="preApprovedStartDate">
                                <el-date-picker
                                        format="d MMM yy"
                                        v-model="formAddSchedule.preApprovedStartDate"
                                        type="date"
                                        value-format="ddMMyyyy"
                                        :placeholder="$t('modal_payXoft_schedulePreApprovedStartDate')"
                                        style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_schedulePreApprovedEndDate')" size="mini" prop="preApprovedEndDate">
                                <el-date-picker
                                        format="d MMM yy"
                                        v-model="formAddSchedule.preApprovedEndDate"
                                        type="date"
                                        value-format="ddMMyyyy"
                                        :placeholder="$t('modal_payXoft_schedulePreApprovedEndDate')"
                                        style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label-width="130px"  label-position="left" :label="$t('modal_payXoft_scheduleDescription')" size="mini" prop="description">
                        <el-input
                                type="textarea"
                                :rows="2"
                                :placeholder="$t('modal_payXoft_scheduleDescription')"
                                v-model="formAddSchedule.description">
                        </el-input>
                    </el-form-item>
                </el-row>
                <div class="flex-end">
                    <el-form-item>
                        <el-button v-if="state === 'create'" @click="create('formAddSchedule')" class="modal__btn" type="primary" plain size="mini">{{$t('general_save')}}</el-button>
                        <el-button v-if="state === 'update'" @click="create('formAddSchedule')" class="modal__btn" type="primary" plain size="mini">{{$t('general_save')}}</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "AddScheduleModal",
    components: {
      SweetModal
    },
    data(){
      return {
        state: 'create',
        id: null,
        // workTimeList
        workTimeList: [],
        workTimeId: null,
        // breakTime
        breakTimeList: [],
        breakTimeId: null,
        // travelTime
        travelTimeList: [],
        travelTimeId: null,

        formAddSchedule: {
          //col 1
          name: null,
          code: null,
          timezone: null,
          timezoneList: [],
          workdaysInYear: null,
          workWeekStartDay: null,
          workWeekStartDayList: [],
          //col 2
          startTime: null,
          // startTimeList: [],
          graceTime: null,
          earlyStartFrom: null,
          // earlyStartFromList: [],
          finishTime: null,
          // finishTimeList: [],
          lateFinishTo: null,
          // lateFinishToList: [],
          //col 3
          startDate: null,
          endDate: null,
          repeat: null,
          //description
          description: null,
          //workTime
          workTimeItems: [],
          preApproved: false,
          preApprovedStartDate: null,
          preApprovedEndDate: null,
          //breakTime
          breakTimeItems: [],
          //travelTime
          travelTimeItems: []

        },
        rules: {
          name: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          code: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          timezone: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          workdaysInYear: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          workWeekStartDay: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          startTime: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          graceTime: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          earlyStartFrom: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          finishTime: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          lateFinishTo: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          startDate: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          endDate: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          preApprovedStartDate: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
          preApprovedEndDate: [
              { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
            ],
        }
      }
    },
    methods:{
      async open(){
        try {
          this.state = 'create';

          this.$refs.addScheduleModal.open();

          const directories = await this.directories();

        } catch (err) {
          console.log(err)
        }
      },
      async openEdit(id){
        try {
          this.state = 'update';
          this.id = id;
          const directories = await this.directories();

          // TODO ITEM HERE

          this.$refs.addScheduleModal.open();

        } catch (err) {
          console.log(err)
        }

      },
      directories(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/workingHoursSchedule/directories?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('response', response.data);
              loader.hide();
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              reject(error)
            });
        })
      },
      create (form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              fields: {
                // col 1
                name: this.formAddSchedule.name,
                code: this.formAddSchedule.code,
                timezone: this.formAddSchedule.timezone,
                workdaysInYear: this.formAddSchedule.workdaysInYear,
                workWeekStartDay: this.formAddSchedule.workWeekStartDay,
                // col 2
                startTime: this.formAddSchedule.startTime,
                graceTime: this.formAddSchedule.graceTime,
                earlyStartFrom: this.formAddSchedule.earlyStartFrom,
                finishTime: this.formAddSchedule.finishTime,
                lateFinishTo: this.formAddSchedule.lateFinishTo,
                // col 3
                startDate: this.formAddSchedule.startDate,
                endDate: this.formAddSchedule.endDate,
                repeat: this.formAddSchedule.repeat,
                preApproved: this.formAddSchedule.preApproved,
                preApprovedStartDate: this.formAddSchedule.preApprovedStartDate,
                preApprovedEndDate: this.formAddSchedule.preApprovedEndDate,
              }
            };
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/workingHoursSchedule/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                console.log('response', response.data);
                loader.hide();
                this.notification(this.$t('general_success'), this.$t('notification_payXoft_scheduleAdded'), "success");
                this.$emit('loadList');
                this.$refs.addScheduleModal.close();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
              });
          } else {
            console.log('not valid')
          }
        })
      },
      update(form){

      },
      close(){
        console.log('close')
      },
      changePreApproved(){

      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.add-schedule-modal {
        .sweet-modal {
            max-width: 1200px !important;
        }
    }
</style>
